import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "./assets/images/logo.png";

const Logo = styled.img`
  height: 75px;
  width: 100px;
  margin-bottom: -1.5rem;

  @media (max-width: 768px) {
    margin-bottom: 0;
    margin-left: 0;
  }
`;

const NavbarContainer = styled.div`
  padding: 1rem;
  position: relative;
  z-index: 2;
  width: 100%;
`;

const NavbarContent = styled.div`
  width: 75%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  
  @media (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
    flex-direction: row;
    align-items: center;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 100;
  
  @media (max-width: 768px) {
    display: block;
  }
  
  span {
    display: block;
    width: 25px;
    height: 2px;
    background-color: #555;
    margin: 5px 0;
    transition: 0.3s;
  }
`;

const NavItems = styled.nav`
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.5rem;
  font-family: 'Inter', sans-serif;
  
  .ul {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${props => props.isOpen ? '0' : '-100%'};
    height: 100vh;
    width: 70%;
    max-width: 300px;
    background: white;
    box-shadow: -2px 0 10px rgba(0,0,0,0.1);
    transition: right 0.3s ease;
    z-index: 99;
    padding: 3rem 2rem 2rem 2rem;
    margin: 0;
    display: flex;
    align-items: flex-start;
    
    .ul {
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;
      width: 100%;
    }
  }
`;

const Overlay = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'block' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 98;
  }
`;

const NavLink = styled(Link)`
  color: #6A89A7;
  text-decoration: none;
  margin: 0 0.8rem;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  font-weight: 400;

  @media (max-width: 768px) {
    margin: 0;
    font-size: 1.3rem;
    width: 100%;
  }

  &:hover {
    text-decoration: underline;
    color: #384959;
  }
`;

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <NavbarContainer>
      <NavbarContent>
        <div className="logo">
          <Link to="/">
            <Logo src={logo} alt="Logo" />
          </Link>
        </div>
        
        <HamburgerButton onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </HamburgerButton>
        
        <Overlay isOpen={isOpen} onClick={closeMenu} />
        
        <NavItems isOpen={isOpen}>
          <div className="ul">
            <div>
              <NavLink to="/Experiences" onClick={closeMenu}>experiences</NavLink>
            </div>
            <div>
              <NavLink to="/Projects" onClick={closeMenu}>projects</NavLink>
            </div>
            <div>
              <NavLink to="/Art" onClick={closeMenu}>artworks</NavLink>
            </div>
            <div>
              <NavLink to="/Photography" onClick={closeMenu}>photos</NavLink>
            </div>
          </div>
        </NavItems>
      </NavbarContent>
    </NavbarContainer>
  );
}

export default Navbar;
